@use "../../../../styles/colors";

:global {
  body[class*="theme-"].theme {
    :local {
      .container {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        width: 22rem;
        height: 2.5rem;
        padding: 0.25rem 0 0.25rem 0.5rem;
        border-radius: 0.5rem;
        background-color: colors.$mmc-soft-gray;
        margin: 0.25rem 0;

        &.danger {
          width: 23.5rem;
          background-color: colors.$mmc-red-010;
        }
      }

      .fileIcon {
        flex-shrink: 0;
        width: 1.25rem;
        height: 1.25rem;
        line-height: 0.75rem;
        svg {
          height: 0.625rem;
        }
      }

      .name {
        flex: 1;
        display: flex;
        align-items: center;
        min-width: 0;
        font-weight: 400;
        font-size: 0.875rem;
        line-height: 1.375rem;
        color: colors.$mmc-soft-slate;
      }

      .namePure {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .nameExtra {
        margin-left: 0.25rem;
        flex-shrink: 0;
      }

      .suffix {
        flex-shrink: 0;
        display: flex;
        align-items: center;
        margin-left: auto;
      }
    }
  }
}
